// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2BpAs","large":"styles_large__3z0AW"};